export const TRACKING_EVENT_TYPE = "onEventTracked"

export type CustomEventTrackData = {
  trackId: string
  payload?: Record<
    string,
    string | boolean | Record<string, unknown> | unknown | undefined
  >
}

export const EventTracker = () => {
  const on = (listener: EventListener) => {
    document.addEventListener(TRACKING_EVENT_TYPE, listener)
  }

  const off = (listener: EventListener) => {
    document.removeEventListener(TRACKING_EVENT_TYPE, listener)
  }

  const trigger = (data?: CustomEventTrackData) => {
    const event = new CustomEvent(TRACKING_EVENT_TYPE, { detail: data })
    document.dispatchEvent(event)
  }

  const onTrackClicks = (listener: EventListener) => () => {
    const selections = document.querySelectorAll("[data-track-id]")
    selections.forEach((selection) => selection.addEventListener("click", listener))
  }

  const offTrackClicks = (listener: EventListener) => () => {
    const selections = document.querySelectorAll("[data-track-id]")
    selections.forEach((selection) => selection.removeEventListener("click", listener))
  }

  return { on, off, trigger, onTrackClicks, offTrackClicks }
}
